import { Card, CardContent, Grid, LinearProgress } from "@material-ui/core";
import {
  Button,
} from "react-bootstrap";
import Axios from "axios";
import DataTable from "react-data-table-component";
import Pagination from "react-js-pagination";
import React, { Component } from "react";
import AppConfig from "../../../config/AppConfig";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
const bgImage = toAbsoluteUrl("/media/bg/bg-10.jpg");
const columns = [
  {
    name: (
      <>
        <div style={{ fontSize: 16 }}>Nama Perguruan Tinggi</div>
      </>
    ),
    selector: row => row.nm_lemb,
    sortable: true,
  },
  {
    name: (
      <>
        <div style={{ fontSize: 16 }}>Aksi</div>
      </>
    ),
    grow: 0,
    width: "150px",
    textAlign: "center",
    cell: (row) => (
      <a
        href={`/detail-pt/` + row.id_sp}
        onClick={() => handleSearch(row)}
        className="btn btn-primary"
      >
        <span className="flaticon-eye"></span>
      </a>
    ),
    // <Button variant="primary" onClick={() => handleSearch(row)}>
    //     Detail &nbsp;&nbsp;&nbsp;&nbsp;
    //     <span className="fa fa-eye"></span>
    // </Button>
  },
];
const handleSearch = (row) => {
  localStorage.setItem("id_sp_temp", row.id_sp);
  localStorage.setItem("nama_id", row.nm_lemb);
  window.location.reload();
};
class Pencarian extends Component {
  state = {
    id_unit: "",
    //filter
    keyword: [],
    kelengkapan_fltr: [],
    lingkup_kordinasi: [],

    data: [],
    loading: false,
    totalRows: 0,
    perPage: 10,
    show: false,
    globalState: [],
    limit: 10,
    last_page: 1,
    jm_pages: 0,
    activePage: 1,
    ref_lingkup: [],
  };
  async componentDidMount() {
    console.log("TEST");
    this.setState({ display: false });
    localStorage.removeItem("tab_actve");
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    // if(id_institusi !== ""){
    //     id_sp = id_institusi;
    // }if(id_institusi === null){
    //     id_sp = sessiondata.i_idunit;
    // }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    console.log("userdata", userdata);
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    if (
      sessiondata.i_idrole === 10 ||
      sessiondata.i_idrole === 2 ||
      sessiondata.i_idrole === 1 ||
      sessiondata.i_idrole === 2013 ||
      sessiondata.i_idrole === 2014 ||
      sessiondata.i_idrole === 29 ||
      sessiondata.i_idrole === 99 ||
      sessiondata.i_idrole === "10" ||
      sessiondata.i_idrole === "2" ||
      sessiondata.i_idrole === "1" ||
      sessiondata.i_idrole === "2013" ||
      sessiondata.i_idrole === "2014" ||
      sessiondata.i_idrole === "29" ||
      sessiondata.i_idrole === "99"
    ) {
      // if(id_institusi !== "" && id_institusi !== null){
      //     this.setState({ show: true });
      // }else{
      var formData = new FormData();
      if (
        sessiondata.i_idrole === 2 ||
        sessiondata.i_idrole === 2013 ||
        sessiondata.i_idrole === 2014 ||
        sessiondata.i_idrole === 29 ||
        sessiondata.i_idrole === "2" ||
        sessiondata.i_idrole === "2013" ||
        sessiondata.i_idrole === "29" ||
        sessiondata.i_idrole === "2014"
      ) {
        formData.append("data[id_unit]", sessiondata.i_idunit);
        if (sessiondata.id_sp_penugasan !== null) {
          if (sessiondata.i_idrole === 2013) {
            var data_pt = "'" + sessiondata.id_sp_penugasan.join("','") + "'";
            formData.append("data[id_sp]", data_pt);
          }
        }
      }
      formData.append("data[id_bp]", sessiondata.i_idbp);

      Axios.post(
        AppConfig.urlApiGetListPT + session + "&limit=" + this.state.limit,
        formData
      )
        .then((res) => {
          console.log(res.data.result);
          console.log(userdata);
          console.log(sessiondata);
          this.setState({
            globalState: res,
            data: res.data.result.data,
            totalRows: res.data.result.total_rows,
            ref_lingkup: res.data.result.ref_lingkup,
            loading: false,
            display: true,
          });
        })
        .catch((err) => {
          alert("not found");
          console.log(err);
          console.log("err ====================================")
          this.setState({
            loading: false,
            display: false,
          });
        });
      // }
    } else {
      this.setState({ show: true });
    }
  }

  handlePageChange = (pageNumber) => {
    const { last_page, jm_pages, limit } = this.state;
    // let jm_page = "";
    //     if(pageNumber > last_page){
    //         jm_page = jm_pages+limit;
    //     }else{
    //         jm_page = jm_pages-limit;
    //     }
    let jm_page = (pageNumber - 1) * 10;
    // console.log("last_page = ",last_page );
    // console.log("jm_pages = ",jm_pages );
    // console.log("jm_page = ",jm_page );
    // console.log("limit = ", limit );
    // console.log("pageNumber = ",pageNumber );
    this.setState({
      loading: false,
      display: false,
      last_page: pageNumber,
      activePage: pageNumber,
      jm_pages: jm_page,
    });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[mengisi]", this.state.kelengkapan_fltr);
    if (
      sessiondata.i_idrole === 2 ||
      sessiondata.i_idrole === 2013 ||
      sessiondata.i_idrole === 2014 ||
      sessiondata.i_idrole === 29 ||
      sessiondata.i_idrole === "2" ||
      sessiondata.i_idrole === "2013" ||
      sessiondata.i_idrole === "29" ||
      sessiondata.i_idrole === "2014"
    ) {
      formData.append("data[id_unit]", sessiondata.i_idunit);
      if (sessiondata.id_sp_penugasan !== null) {
        if (sessiondata.i_idrole === 2013) {
          var data_pt = "'" + sessiondata.id_sp_penugasan.join("','") + "'";
          formData.append("data[id_sp]", data_pt);
        }
      }
    } else {
      formData.append("data[id_unit]", this.state.lingkup_kordinasi);
    }
    formData.append("data[id_bp]", sessiondata.i_idbp);
    Axios.post(
      AppConfig.urlApiGetListPT +
      session +
      "&limit=" +
      limit +
      "&page=" +
      jm_page,
      formData
    )
      .then((res) => {
        this.setState({
          data: res.data.result.data,
          totalRows: res.data.result.total_rows,
          loading: false,
          display: true,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        console.log(err);
      });
  };
  SearchInstitusi = (e) => {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    console.log(sessiondata);
    let id_institusi = localStorage.getItem("id_sp_temp");
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    e.preventDefault();
    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[mengisi]", this.state.kelengkapan_fltr);
    if (
      sessiondata.i_idrole === 2 ||
      sessiondata.i_idrole === 2013 ||
      sessiondata.i_idrole === 2014 ||
      sessiondata.i_idrole === 29 ||
      sessiondata.i_idrole === "2" ||
      sessiondata.i_idrole === "2013" ||
      sessiondata.i_idrole === "29" ||
      sessiondata.i_idrole === "2014"
    ) {
      formData.append("data[id_unit]", sessiondata.i_idunit);
      if (sessiondata.id_sp_penugasan !== null) {
        if (sessiondata.i_idrole === 2013) {
          var data_pt = "'" + sessiondata.id_sp_penugasan.join("','") + "'";
          formData.append("data[id_sp]", data_pt);
        }
      }
    } else {
      formData.append("data[id_unit]", this.state.lingkup_kordinasi);
    }
    formData.append("data[id_bp]", sessiondata.i_idbp);
    // if (sessiondata.i_idrole === 2 || sessiondata.i_idrole === 2013 || sessiondata.i_idrole === 2014 ||
    //     sessiondata.i_idrole === "2" ||  sessiondata.i_idrole === "2013" ||  sessiondata.i_idrole === "2014"){
    //     formData.append('data[id_unit]', sessiondata.i_idunit);
    //     formData.append('data[id_unit]', sessiondata.i_idrole);
    // }
    this.setState({ loading: true });
    Axios.post(
      AppConfig.urlApiGetListPT + session + "&limit=" + this.state.limit,
      formData
    )
      .then((res) => {
        console.log(res.data.result.data);
        this.setState({
          data: res.data.result.data,
          totalRows: res.data.result.total_rows,
          loading: false,
          display: true,
          full: res,
        });
      })
      .catch((err) => {
        alert("not found");
        console.log(err);
        this.setState({
          loading: false,
          display: false,
        });
      });
  };
  ResetFilter = (e) => {
    e.preventDefault();
    this.setState({
      keyword: "",
      kelengkapan_fltr: "",
      lingkup_kordinasi: "",
    });
    this.componentDidMount();
  };
  onInputChangeName = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  render() {
    let named = localStorage.getItem("nama_id");
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const {
      loading,
      data,
      totalRows,
      show,
      keyword,
      ref_lingkup,
      kelengkapan_fltr,
      lingkup_kordinasi,
    } = this.state;
    var i = 0;
    let result_ref = [];
    for (var key in ref_lingkup) {
      result_ref[i] = {
        name: key,
        result: ref_lingkup[key],
      };
      i++;
    }
    let display_return = "";
    if (this.state.display === true) {
      display_return = (
        <>
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <DataTable
                style={{ marginTop: "-50px" }}
                progressPending={loading}
                columns={columns}
                data={data}
              />
            </Grid>
            <Grid item xs={4}>
              <span
                style={{
                  fontStyle: "italic",
                  fontSize: "12px",
                  color: "#b5b5b5",
                }}
              >
                Total data : &nbsp;{this.state.totalRows}
              </span>
            </Grid>
            <Grid item xs={8} style={{ textAlign: "right" }}>
              <Pagination
                hideDisabled
                // add itemClass and LinkClass
                itemClass="page-item"
                linkClass="page-link"
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.limit}
                totalItemsCount={totalRows}
                pageRangeDisplayed={10}
                onChange={this.handlePageChange.bind(this)}
              />
            </Grid>
          </Grid>
        </>
      );
    } else {
      display_return = (
        <>
          <LinearProgress color="secondary" variant="query" />
        </>
      );
    }
    const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;
    return (
      <>
        <div
          className="row row-paddingless"
          style={{
            backgroundImage: `url(${bgImage})`,
            padding: "2%",
            borderRadius: "5px",
          }}
        >
          <div className="col-md-12 text-white" style={{ textAlign: "left" }}>
            <h2 className="font-weight">Pencarian Perguruan Tinggi</h2>
            <hr />
          </div>
          <div className="col-md-12 text-white" style={{ textAlign: "" }}>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Kata Kunci
              </label>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <input
                    type="text"
                    value={keyword}
                    onChange={(e) => this.onInputChangeName(e, "keyword")}
                    className={`form-control form-control-lg form-control-solid `}
                    placeholder="Masukan keyword : Nama Perguruan Tinggi"
                    name="nama"
                  />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 text-white">
                Kelengkapan Pengaturan Kebijakan SPMI
              </label>
              <div className="col-lg-9 col-xl-6">
                <select
                  value={kelengkapan_fltr}
                  onChange={(e) =>
                    this.onInputChangeName(e, "kelengkapan_fltr")
                  }
                  className="form-control form-control-lg form-control-solid"
                  name="language"
                >
                  <option value="">Semua Kategori</option>
                  <option value="lengkap">Lengkap</option>
                  <option value="belumlengkap">Belum Lengkap</option>
                  <option value="tidakmengisi">Tidak Mengisi</option>
                </select>
              </div>
            </div>
            {userdata.i_idrole === "2013" ||
              userdata.i_idrole === "2014" ||
              userdata.i_idrole === 2013 ||
              userdata.i_idrole === 2014 ? (
              ""
            ) : (
              <>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 text-white">
                    Lingkup Koordinasi
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <select
                      value={lingkup_kordinasi}
                      onChange={(e) =>
                        this.onInputChangeName(e, "lingkup_kordinasi")
                      }
                      className="form-control form-control-lg form-control-solid"
                      name="language"
                    >
                      <option value="">Semua Unit</option>
                      {result_ref.map((list, i) => (
                        <option value={list.name}>{list.result}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            )}
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label"></label>
              <div
                className="col-lg-9 col-xl-6"
                style={{ textAlign: "center" }}
              >
                <Button variant="primary" onClick={this.SearchInstitusi}>
                  Filter Data &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-search"></span>
                </Button>
                <Button
                  variant="default"
                  onClick={this.ResetFilter}
                  style={{ marginLeft: "10px" }}
                >
                  Reset &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-times"></span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <br />

        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} style={{ textAlign: "left" }}>
                {display_return}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </>
    );
  }
}
export default Pencarian;
